<div
  class="ctx-item flex-row align-center g-space-sm py-space-sm px-space-md"
  [class.disabled]="this.params?.disabled"
  (click)="this.onClick()"
  (mouseenter)="this.onMouseEnter()"
>
  <span class="ctx-icon flex-row align-center">
    @if (this.params && this.params.icon) {
      <cam-font-icon [name]="this.params.icon" type="sm"></cam-font-icon>
    }
  </span>
  <cam-text class="flex-1" size="sm">{{ this.params?.name ?? '' | translate }}</cam-text>
  @if (this.hasSubMenu) {
    <cam-font-icon class="ctx-chevron" name="arrow-big-right" type="sm"></cam-font-icon>
  }
</div>
